import { render, staticRenderFns } from "./LvInfoQuesOptionList.vue?vue&type=template&id=bfa5b8e0"
import script from "./LvInfoQuesOptionList.vue?vue&type=script&lang=js"
export * from "./LvInfoQuesOptionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports